import $ from "jquery";
import { throttle } from "throttle-debounce";
import stickybits from "stickybits";

const SELECTOR_STICKY_CONTAINER = '[data-js="jsSticky"]';
const SELECTOR_SECTION_TITLE = "[data-nav]";
const SELECTOR_SIDEBAR = ".c-nav-sidebar";
const SELECTOR_HEADER = ".l-module--page-header";

const sectionVisibilities = {};

const stickyNav = function () {
  const STICKY_PARENT = $(SELECTOR_STICKY_CONTAINER).parent().attr("class");

  stickybits(`.${STICKY_PARENT}`, { stickyBitStickyOffset: 145 });
};

const createNav = function () {
  const $sidebar = $("<ul />");

  $(SELECTOR_SECTION_TITLE).each(function () {
    const $section = $(this);
    const $navItem = $("<li />").appendTo($sidebar);
    const title = $section.data("nav");
    const anchor = title.replace(/\s+/g, "").replace(/&/g, "And");

    const $link = $("<a />", {
      text: title,
      href: `#${anchor}`,
      "data-section": title,
    }).appendTo($navItem);

    $navItem.on("click", $link, handleAnchor);
  });

  $sidebar.appendTo(SELECTOR_SIDEBAR);
};

const calculateSectionVisibility = function ($section) {
  const loggedInOffset = $("#toolbar-administration").length
    ? $("#toolbar-administration").outerHeight()
    : 0;
  const fixedHeaderHeight = $(SELECTOR_HEADER).outerHeight() + loggedInOffset;
  const windowHeight = $(window).height() - fixedHeaderHeight;
  const docScroll = $(document).scrollTop();
  const sectionPosition = $section.offset().top - fixedHeaderHeight;
  const sectionHeight = $section.height();
  const hiddenBefore = docScroll - sectionPosition;
  const hiddenAfter =
    sectionPosition + sectionHeight - (docScroll + windowHeight);

  if (
    docScroll > sectionPosition + sectionHeight ||
    sectionPosition > docScroll + windowHeight
  ) {
    return 0;
  }
  let percentAmount = 100;

  if (hiddenBefore > 0) {
    percentAmount -= (hiddenBefore * 100) / sectionHeight;
  }

  if (hiddenAfter > 0) {
    percentAmount -= (hiddenAfter * 100) / sectionHeight;
  }

  return percentAmount;
};

const observeSections = function () {
  $(SELECTOR_SECTION_TITLE).each(function (index) {
    sectionVisibilities[index] = calculateSectionVisibility($(this));
  });

  const isInvisible = Object.values(sectionVisibilities).every(
    (x) => x === 0 || x === "",
  );

  if (!isInvisible) {
    const activeSection = Object.keys(sectionVisibilities).reduce((a, b) =>
      sectionVisibilities[a] > sectionVisibilities[b] ? a : b,
    );

    $(SELECTOR_SIDEBAR).find("li a").removeClass("is-active");
    $(SELECTOR_SIDEBAR).find("li a").eq(activeSection).addClass("is-active");
  }
};

const scrollToTarget = function (id) {
  const $target = $(`[data-nav="${id}"]`);
  const loggedInOffset = $("#toolbar-administration").length
    ? $("#toolbar-administration").outerHeight()
    : 0;

  if ($target.length) {
    $("html,body").animate(
      {
        scrollTop:
          $target.offset().top -
          $(SELECTOR_HEADER).outerHeight() -
          loggedInOffset -
          32,
      },
      500,
    );
  }
};

const handleScroll = throttle(200, () => {
  observeSections();
});

const handleAnchor = function (event) {
  if ("data" in event) {
    const target = event.data.attr("data-section");

    scrollToTarget(target);
  }
};

$(function () {
  if ($(SELECTOR_STICKY_CONTAINER).length !== 0) {
    stickyNav();
    createNav();
    observeSections();

    if (window.location.hash) {
      const id = window.location.hash;
      const target = $(SELECTOR_SIDEBAR)
        .find(`li a[href="${id}"]`)
        .attr("data-section");

      scrollToTarget(target);
    }

    $(window).on("scroll", handleScroll);
  }
});
